import React from 'react'
import { connect } from 'react-redux';
import { dispatch } from 'rxjs/internal/observable/pairs';
import { dataType } from '@/constants/data-type';
import DataTable from '@/components/DataTable/DataTable';
import { userActions } from '@/actions/user';
import { stockActions } from '@/actions/trading/stock.action';
import { ACTION_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY, REFRESH_DATA } from '@/constants/app';
import { utilsFunction, Converter, Comparator } from "@/helpers/functions";
import { PARAMS as requestParams } from '@/constants/params';
import { getPortfolioAction } from '@/actions/trading';
import Watchlistfilter from './Watchlistfilter'
import { openPlaceOrderDialog } from '@/actions/app'
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';
import '@/assets/styles/commons/_styles.scss'

class Watchlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: null,
      portfolio: [{
        id: '1', title: 'portfolio_title', isActive: false
      }],
      columnDefs:[
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'symbol',
          tooltipField:'symbol',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SYMBOL,
          cellRendererParams: {
            action:  this.toQuotePage.bind(this)
          },
          minWidth: 140,
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'stockName',
          tooltipField:'stockName',
          headerClass: 'table-header',
          cellClass: 'table-cell  table-ellipsis',
          dataType: dataType.TEXT,
          minWidth:300,
        },
        {
          headerName: props.language.common_price,
          colId: 'common_price',
          field: 'price',
          tooltipField: 'price',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 67,
          cellRendererParams: {
            action:  this.openPricePlaceorder.bind(this)
          },
          maxWidth:100
        },
        {
          headerName: props.language.common_change,
          colId: 'common_change',
          field: 'change',
          tooltipField: 'change',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          bindingColor: true,
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth:125,
          maxWidth:200
        },
        {
          headerName: props.language.common_quantity,
          colId: 'common_quantity',
          field: 'quantity',
          tooltipField:'field',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          cellRendererParams: {
            action:  this.openQuantityPlaceorder.bind(this)
          },
          minWidth:104,
          maxWidth:170
        },
        {
          headerName: props.language.common_market_value,
          colId: 'common_market_value',
          field: 'marketv',
          tooltipField: 'marketv',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 100,
          maxWidth:150
        },
        {
          headerName: props.language.common_cost,
          colId: 'common_cost',
          field: 'cost',
          tooltipField: 'cost',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.AVG_PRICE,
          comparator: Comparator.numberComparator,
          minWidth: 84,
          maxWidth:180
        },
        {
          headerName: props.language.common_tradable_quantity,
          colId: 'common_tradable_quantity',
          field: 'tradableq',
          tooltipField: 'tradableq',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:180
        },
        {
          headerName: props.language.common_PL_percent,
          colId: 'common_PL_percent',
          field: 'pl',
          tooltipField: 'pl',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.PERCENT_BASED,
          bindingColor: true,
          // comparator: Comparator.numberComparator,
          minWidth: 140,
          maxWidth:300
        },
        {
          headerName: props.language.common_volume,
          colId: 'common_volume',
          field: 'volume',
          tooltipField: 'volume',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 100,
          maxWidth:190
        },
        {
          headerName: props.language.common_open,
          colId: 'common_open',
          field: 'open',
          tooltipField: 'open',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 80,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_high,
          colId: 'market_quote_high',
          field: 'high',
          tooltipField: 'high',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 80,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_low,
          colId: 'market_quote_low',
          field: 'low',
          tooltipField: 'low',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 80,
          maxWidth:170
        },
        {
          headerName: props.language.common_turnover,
          colId: 'common_turnover',
          field: 'turnover',
          tooltipField: 'turnover',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 130,
          maxWidth:200
        },
        {
          headerName: props.language.common_turnover_rate,
          colId: 'common_turnover_rate',
          field: 'turnoverRate',
          tooltipField: 'turnoverRate',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          // bindingColor: true,
          dataType: dataType.PERCENT_BASED,
          minWidth: 114,
          maxWidth:170  
        },
        {
          headerName: props.language.market_quote_prev_close,
          colId: 'market_quote_prev_close',
          field: 'prevclose',
          tooltipField: 'prevclose',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        },
        // {
        //   headerName: props.language.market_quote_mkt_cap,
        //   colId: 'market_quote_mkt_cap',
        //   field: 'mktcap',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell',
        //   dataType: dataType.CURRENCY,
        //   comparator: Comparator.numberComparator
        // },
        {
          headerName: props.language.market_quote_pb,
          colId: 'market_quote_pb',
          field: 'pb',
          tooltipField: 'pb',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 70,
          maxWidth:170
        },
        
        // {
        //   headerName: props.language.common_close,
        //   colId: 'common_close',
        //   field: 'close',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell',
        //   dataType: dataType.CURRENCY,
        //   comparator: Comparator.numberComparator
        // },
        {
          headerName: props.language.market_quote_52wk_high,
          colId: 'market_quote_52wk_high',
          field: 'wkh',
          tooltipField: 'wkh',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_52wk_low,
          colId: 'market_quote_52wk_low',
          field: 'wkl',
          tooltipField: 'wkl',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_shares,
          colId: 'market_quote_shares',
          field: 'shares',
          tooltipField: 'shares',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 110,
          maxWidth:200
        },
        {
          headerName: props.language.market_quote_h_mkt_cap,
          colId: 'market_quote_h_mkt_cap',
          field: 'hmktc',
          tooltipField: 'hmktc',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 110,
          maxWidth:200
        },
        {
          headerName: props.language.market_quote_h_shares,
          colId: 'market_quote_h_shares',
          field: 'hshares',
          tooltipField: 'hshares',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 110,
          maxWidth:200
        },
        {
          headerName: props.language.market_quote_p_elyr,
          colId: 'market_quote_p_elyr',
          field: 'pelyr',
          tooltipField: 'pelyr',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 70,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_epslyr,
          colId: 'market_quote_epslyr',
          field: 'epslyr',
          tooltipField: 'epslyr',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_dividend_percent,
          colId: 'market_quote_dividend_percent',
          field: 'dividendp',
          tooltipField: 'dividendp',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.PERCENT_BASED,
          minWidth: 114,
          maxWidth:170
        },
        {
          headerName: props.language.market_quote_dividend,
          colId: 'market_quote_dividend',
          field: 'dividend',
          tooltipField: 'dividend',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 114,
          maxWidth:170
        },
        // {
        //   headerName: props.language.market_quote_roe,
        //   colId: 'market_quote_roe',
        //   field: 'roe',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell',
        //   dataType: dataType.NUMBER,
        //   comparator: Comparator.numberComparator
        // },
        // {
        //   headerName: props.language.market_quote_roa,
        //   colId: 'market_quote_roa',
        //   field: 'roa',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell',
        //   dataType: dataType.NUMBER,
        //   comparator: Comparator.numberComparator
        // },
      ], 
      refresh:true,
      dateNow:''
    }
    if(props.onRef){
      props.onRef(this)
    }
  }

  componentDidMount() {
    const { currentTradingAccount, token , profile ,user} = this.props
    // if (currentTradingAccount && token) { 
      if(profile && user.token){
        this.getPostion()
      }
    // 

  }

  componentDidUpdate(preProps) {
    const { userInfo, isNeedRefresh,language ,marketCode ,currentTradingAccount ,user , mdsToken} = this.props;
    if (userInfo && preProps.userInfo !== userInfo && JSON.stringify(preProps.userInfo ) !='{}') {
      if(marketCode === 'position'){
        if(user.token){
          this.getPostion()
        }   
      }else if(marketCode === ''){
        this.WatchlistRef.getPostion()
      }else{
        this.WatchlistRef.getWatchLists(marketCode)
      }
    }
    if (language && preProps.language !== language) {
      if(marketCode === 'position'){
        this.getPostion()
      }else if(marketCode === ''){
        // this.WatchlistRef.getPostion()
      }else{
        // this.WatchlistRef.getWatchLists(marketCode)
      }
    }

    // if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
    //   if(marketCode === 'position'){
    //     this.getPostion()
    //   }else if(marketCode === ''){
    //     this.WatchlistRef.getPostion()
    //   }else{
    //     this.WatchlistRef.getWatchLists(marketCode)
    //   }
    // }
    if (currentTradingAccount && preProps.currentTradingAccount !== currentTradingAccount && JSON.stringify(preProps.currentTradingAccount) !='{}') {
      if(user.token){
        this.getPostion()
      }
    }
    if(mdsToken && mdsToken != preProps.mdsToken){
      this.getPostion()
    }
  }

  toQuotePage = (data) => {
    if(data.symbol.indexOf('FUND') != -1) return
    // if(this.state.refresh) return
    let stock = data.symbol
    const marketID = stock.substring(0, stock.indexOf("."))
    if(!this.props.markets.find(item => marketID === item.value)){
      return
    }
    if (marketID === 'USEX') {
      const stockID = stock?.split('.')?.[1]
      this.props.setStock({ stockCode: stockID, marketID }, () => {
        this.props.onClickSymbol(marketID, stockID)
      })
    } else {
      let stockID = stock.substring(stock.indexOf(".") + 1).split('').findIndex(i => i !== '0')
      if (stockID > -1) {
        stockID = stock.substring(stock.indexOf(".") + 1).substr(stockID)
      }
      // if(this.props.profile){
        this.props.setStock({ stockCode: utilsFunction.instrumentIDZeroPadding(stockID), marketID: stock.substring(0, stock.indexOf(".")) }, () => {
          this.props.onClickSymbol(stock.substring(0, stock.indexOf(".")) , utilsFunction.instrumentIDZeroPadding(stockID))
        })
      // }
    }
  }


  getPostion = (callback) => {
    this.setState({rowData:null})
    this.tableRef?.toggleLoadingOverlay(true);
    const { user, currentTradingAccount, language , mdsToken} = this.props
    const { clientID,tradingAccSeq } = currentTradingAccount
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      [requestParams.TRADING_ACC_SEQ]: tradingAccSeq
    }
    const dateNow = Date.now()
    this.setState({dateNow: dateNow})
    this.props.getAccountPortfolio(params, res => {
      if(dateNow != this.state.dateNow) return
      if (Array.isArray(res.portfoliosList) && res.portfoliosList.length) {
        const lang = this.props.language.lang
        const sample = ['symbol', 'stockName', 'price', 'change', 'quantity',
        'marketv','cost', 'tradableq','pl','volume', 'open','high', 'low',
        'turnover' , 'turnoverRate', 'prevclose', 'mktcap', 'pb','wkh','wkl', 'shares',
        'hmktc' , 'hshares' , 'pelyr' ,'epslyr', 'dividendp' , 'dividend',
      ].reduce((prev, next) => (prev[next] = '-', prev), {})
        const filted = res.portfoliosList
        const rowData = []

        for (let i = 0; i <  filted.length; i++) {
          const item = filted[i]

          const deepSample = JSON.parse(JSON.stringify(sample))
          deepSample.symbol = [item.marketID, item.stockCode].join('.')
          
          deepSample.quantity = item.ledgerQty
          deepSample.cost = item.totalAverageCost
          deepSample.tradableq = item.tradableQty
          deepSample.marketv = item.marketValue
          deepSample.pl = `${utilsFunction.datatableCurrencyFormatter(item.floatingPL,2)} (${utilsFunction.datatableFormatPercent(item.floatingPLPercent)})`  
          if (lang === 'zh_TW' || lang === 'zh_CN') {
            deepSample.stockName = item.stockChineseShortName
            if(!item.stockChineseShortName){
              deepSample.stockName = item.stockName
            }
          } else {
            deepSample.stockName = item.stockName
          }
          let stockID = item.stockCode.split('').findIndex(i => i !== '0')
          if (stockID > -1) stockID = item.stockCode.substr(stockID)
          const marketID = Converter.mappingWebSocketMarket(item.marketID)
          // const dparams = { instrumentID: item.stockCode, exchangeID: item.marketID }
          if (marketID === 'XNYS') {
            const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
            stockActions.getBestBidBestAskAction(params, bestBidBestAskRes => {
              if(dateNow != this.state.dateNow) return
              const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
              const deepSample = oneNewRowData?.[i]
              if (deepSample) {
                deepSample.bid = Array.isArray(bestBidBestAskRes.bestBid) ? bestBidBestAskRes.bestBid?.[0]?.price : bestBidBestAskRes.bestBid?.price
                deepSample.ask = Array.isArray(bestBidBestAskRes.bestAsk) ? bestBidBestAskRes.bestAsk?.[0]?.price : bestBidBestAskRes.bestAsk?.price 
                requestAnimationFrame(() =>this.setState({ rowData: oneNewRowData }))
              }
            })
            stockActions.getStatisticsAction(params, statisticsRes => {
              if(dateNow != this.state.dateNow) return
              const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
              const deepSample = twoNewRowData?.[i]
              if (deepSample) {
                deepSample.price = statisticsRes.last
                deepSample.open = statisticsRes.open
                deepSample.high = statisticsRes.high
                deepSample.low = statisticsRes.low
                deepSample.volume = statisticsRes.volume
                deepSample.turnover = statisticsRes.turnover
                stockActions.getClosingPriceAction(params, closingPriceRes => {
                  const threeNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                  const deepSample = threeNewRowData?.[i]
                  if (deepSample) {
                    deepSample.prevclose = closingPriceRes.closingPrice
                    deepSample.change = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)} (${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                    requestAnimationFrame(() =>this.setState({ rowData: threeNewRowData }))
                  }
                })
                requestAnimationFrame(() =>this.setState({ rowData: twoNewRowData }))
              }
            })
          } else {
            const dparams = {
              symbols: [
                {
                  exchangeID: marketID,
                  key: stockID
                }
              ],
              sessID:mdsToken
            }
            const params = {
              msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
              symbol: { exchangeID: marketID, key: stockID },
              language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
            }
            this.props.getFinancial(params, financialres => {
              if(dateNow != this.state.dateNow) return
              if (financialres && Object.keys(financialres).length ) {
                const oneNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                if(!oneNewRowData) return
                const deepSample = oneNewRowData[i]
                if(deepSample){
                  Object.assign(deepSample, { pb: financialres.pbRatio, wkh: financialres.w52High,
                    wkl: financialres.w52Low  ,shares:financialres.totalCapital ,hmktc:financialres.cirMarketCap,
                    hshares:financialres.circCapital, pelyr:financialres.earnps, epslyr:financialres.peRatio, dividendp:utilsFunction.formatPercent(financialres.yield),
                    dividend:financialres.dividend,
                  })
                  this.props.getDetailPriceInfo(dparams, quetores => {
                    if (quetores && Object.keys(quetores).length) {
                      const twoNewRowData = JSON.parse(JSON.stringify(this.state.rowData))
                      if(!twoNewRowData) return
                      const deepSample = twoNewRowData[i]
                      deepSample.price = quetores.last
                      deepSample.turnoverRate = quetores.turnoverRate ? utilsFunction.formatPercent(quetores.turnoverRate) : '-'
                      deepSample.open = quetores.open
                      deepSample.high = quetores.high
                      deepSample.low = quetores.low
                      deepSample.volume = quetores.vol
                      // deepSample.close = quetores.prev
                      deepSample.turnover = quetores.turnover
                      deepSample.prevclose = quetores.prev
                      deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                      deepSample.floatc = quetores.last * financialres.circCapital
                      deepSample.bid = quetores?.bids?.[0]?.price
                      deepSample.ask = quetores?.asks?.[0]?.price
                      this.setState({ rowData: twoNewRowData })
                    }
                  })
                  this.setState({ rowData: oneNewRowData })
                }
              }
            })
          }
          rowData.push(deepSample)
        }
        this.setState({ rowData , refresh:false})
      }else{
        this.setState({rowData: [],  refresh:false})
      }
      typeof callback === 'function' && callback()
      this.tableRef.toggleLoadingOverlay(false);
    })
  }

  openPricePlaceorder=(data)=>{
    if(data.symbol.indexOf('FUND') != -1) return
    let marketID = data.symbol.split('.')[0]
    if(!this.props.markets.find(item => marketID === item.value)){
      return
    }
    const datalist = {
      marketID,
      instrumentID:data.symbol.split('.')[1],
      price: data.price,
      quantity: data.quantity
    }
    this.props.setPlaceOrderParams(datalist)
    // openPlaceOrderDialog(null,datalist,true)
  }
  
  openQuantityPlaceorder=(data)=>{
    let marketID = data.symbol.split('.')[0]
    if(!this.props.markets.find(item => marketID === item.value)){
      return
    }
    const datalist = {
      marketID,
      instrumentID:data.symbol.split('.')[1],
      price: data.price,
      quantity : data.quantity,
    }
    this.props.setPlaceOrderParams(datalist)
    // openPlaceOrderDialog(null,datalist,true)
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

  
  render() {
    const { rowData, columnDefs } = this.state;
    const { language, autoSize , marketCode, innRef} = this.props;
    return (
      <div className="watchlist-container" style={{ flexGrow: 1 }}>
          {marketCode != 'position' ?
          <Watchlistfilter innerRef={e=>{
            this.WatchlistRef = e
            innRef(e)
          }} marketCode={marketCode} toQuotePage={(data)=>this.toQuotePage(data)}
          initHeader={this.props.initHeader}/>
          :
          <DataTable
          name={TABLE_CONFIGURABLE_KEYS.TRADE_WATCHLIST_POSITION}
          innerRef={e => this.tableRef = e}
          columnDefs={columnDefs}
          autoSizeColumns={autoSize}
          data={rowData} autoSizeColumns={true} />}
      </div>
    )
  }

}

Watchlist.defaultProps = {
  isFilter: false,
  autoSize: true
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    marketParams: state.trade.marketParams,
    userInfo: state.user.userInfo,
    isNeedRefresh: state.refresh.marketAction,
    mdsToken: state.trade.mdsToken,
    user: state.auth.user,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets],
  }),
  dispatch => ({
    getWatchlist: (p, c) => dispatch(userActions.getWatchlistAction(p, c)),
    getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
    toggleRefreshMarket: (p) => dispatch({
      type: REFRESH_DATA.MARKET_ACTION,
      value: p
    }),
    getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
    setPlaceOrderParams: (p) => dispatch(stockActions.setPlaceOrderParamsAction(p))
  })
)(Watchlist)
